import { APP_BASE_HREF } from '@angular/common';
import { ApplicationConfig, NgZone, importProvidersFrom } from '@angular/core';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideLoaders } from '@frontend/loaders';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideCoralSportsFeatures } from '@frontend/oxygen/host-app';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideLazySportsHttpInterceptors, provideSportsWebRootServices } from '@frontend/sports/web/providers-data-access';
import { provideVanillaCore } from '@frontend/vanilla/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule, provideStore } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideLottie } from '../../casino/app/src/lottie-options.provide';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { providePaymentsFeatures } from '../../payments/cashier-app/src/app/payments.feature';
import { appRoutes } from './app.routes';
import { extProviders } from './environments/environment';
import { provideHostRouter } from './host-router';
import { provideHostApp } from './provide';
import { provideRxRenderStrategiesWithHydrationSupport } from './server-overrides/rx-render-strategies';
import { provideViewTransitions } from './view-transition/view-transition.provider';

export const getAppConfig = (): ApplicationConfig => ({
    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        {
            provide: NgZone,
            useValue: new NgZone({ shouldCoalesceEventChangeDetection: true }),
        },
        provideClientHydration(
            withEventReplay(),
            withHttpTransferCacheOptions({
                includePostRequests: true,
                filter: (req) => !!req.transferCache,
            }),
        ),
        provideHostRouter(appRoutes),
        provideAnimationsAsync(),
        importProvidersFrom(
            StoreModule.forRoot(
                {},
                {
                    runtimeChecks: {
                        strictStateImmutability: false,
                        strictActionImmutability: false,
                        strictStateSerializability: false,
                        strictActionSerializability: false,
                    },
                },
            ),
            EffectsModule.forRoot([]),
        ),
        provideStore(
            {},
            {
                runtimeChecks: {
                    strictStateImmutability: false,
                    strictActionImmutability: false,
                    strictStateSerializability: false,
                    strictActionSerializability: false,
                },
            },
        ),
        provideVanillaCore(provideLazySportsHttpInterceptors()),
        provideLoaders(),
        provideHostApp(),
        provideSportsWebRootServices(),
        extProviders,
        provideViewTransitions(),
        providePaymentsFeatures(),
        provideCoralSportsFeatures(),
        provideLottie(),
        provideRxRenderStrategiesWithHydrationSupport(),
    ],
});
